import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
} from 'vue';

import RateIt from '@/components/ui/rating/RateIt.vue';


const __default__ = {
  name: 'RatingRender',
};

type Props = {
  displayValue: string | number,
  editable: boolean,
  field?: {
    format: {
      allow_half: boolean,
      max: number,
    },
  },
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    displayValue: null,
    editable: { type: Boolean },
    field: null
  },
  setup(__props: any) {

const props = __props as {
  displayValue: string | number,
  editable: boolean,
  field?: {
    format: {
      allow_half: boolean,
      max: number,
    },
  },
};



const increment = computed(() => (props.field?.format?.allow_half ? 0.5 : 1));
const maxRating = computed(() => parseInt(
  String(props.field?.format?.max || 0),
  10,
));
const rating = computed(() => Number(props.displayValue));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RateIt, {
    rating: _unref(rating),
    "read-only": !props.editable,
    "show-rating": false,
    "max-rating": _unref(maxRating),
    increment: _unref(increment),
    "item-size": 20,
    "icon-type": "star"
  }, null, 8, ["rating", "read-only", "max-rating", "increment"]))
}
}

})